/**
 * 회원 국가몰(country-mall) — user-service 가 회원을 국가몰 단위로 분리하면서 추가된
 * `mallCode` 의 BO 측 단일 소스.
 *
 * ★코드 = BCP-47 `ko-KR/en-US/ja-JP/zh-CN`(하이픈). 조율 정본(00-COORDINATION §몰 코드) 및
 * 코드베이스의 다른 노출몰 상수(ORDER_MALLS·EXPOSED_MALLS·COLLECTION_MALLS)와 동일 포맷이다.
 *
 * ★왜 목록/상세에 항상 노출하는가: 같은 아이디·이메일이 몰마다 따로 존재할 수 있고 KR 회원과
 * US 회원은 별개 계정이다. 몰 구분 없이 아이디로 검색하면 동명이인 계정이 여러 건 나오므로,
 * 몰을 함께 보여주지 않으면 운영자가 엉뚱한 몰의 회원을 조작할 수 있다.
 */

/** 국가몰 코드(정본 순서) — `GET /api/admin/v1/users?mallCode=` 값 및 응답 `mallCode` 와 1:1. */
export const USER_MALLS = ['ko-KR', 'en-US', 'ja-JP', 'zh-CN'] as const;
export type UserMall = (typeof USER_MALLS)[number];

const USER_MALL_SET: ReadonlySet<string> = new Set<string>(USER_MALLS);

/**
 * 알 수 없는/누락 값을 거른 국가몰 코드 narrowing(응답 방어 — 미지원 코드는 null).
 * 라벨 조회 전에 통과시켜 `users.mall.undefined` 같은 RAW KEY 노출을 막는다.
 */
export const asUserMall = (value: string | null | undefined): UserMall | null =>
  value != null && USER_MALL_SET.has(value) ? (value as UserMall) : null;
